


































































































































































































import { InformationType } from "@/common/models";
import { SharedState } from "@/common/state";
import PassivePopup from "@/components/PassivePopup.vue";
import SensitivityLabel from "@/components/SensitivityLabel.vue";
import { emptyFn } from "@/fp";
import {
  computed,
  onBeforeUnmount,
  onMounted,
  Ref,
  ref,
  watch,
} from "@vue/composition-api";
import Vue from "vue";
export default Vue.extend({
  props: {
    l0_l1: {
      type: Array,
      default() {
        return [];
      },
    },
    sensitivity_type: {
      type: String,
      default: "",
    },
    filter_sensitivities: {
      type: Array,
      default() {
        return [0, 1, 2, 3];
      },
    },
  },
  components: { PassivePopup, SensitivityLabel },
  setup(props, { emit }) {
    const show_popup = ref(false);
    const info_tree: Ref<any[]> = ref([]);
    const selected_item_name = ref("");
    const selected_item: Ref<InformationType> = ref({
      ...SharedState.default_label.value,
      sensitivities: { 0: true },
    });

    const _l0_l1 = computed(() => props.l0_l1 as [string, string]);

    const subs = {
      l0l1: emptyFn(),
    };

    const for_each_leaf_in_tree = (fn: (leaf: any) => boolean) => {
      return function exec(tree: any) {
        for (let item of tree) {
          item = fn(item);
          if (item.nested) {
            exec(item.nested);
          }
        }
        return tree;
      };
    };

    const set_visibility_by_sensitivities_filter = for_each_leaf_in_tree(
      (leaf: any) => {
        if (leaf.sensitivities) {
          leaf.visible = (props.filter_sensitivities as number[]).some(
            (level) => level in leaf.sensitivities
          );
        } else {
          leaf.visible = (props.filter_sensitivities as number[]).includes(
            leaf.sensitivityLevel
          );
        }
        return leaf;
      }
    );

    const set_tree = () => {
      info_tree.value = SharedState.get_raw_info_types_tree([
        _l0_l1.value[0],
        _l0_l1.value[1],
      ]);
      // adding the parent to the tree
      {
        const parent = info_tree.value[0].parentId;
        if (parent !== "L0") {
          info_tree.value = [
            {
              ...SharedState.getInfoType(parent),
              nested: info_tree.value,
            },
          ];
        }
      }
      // @ts-ignore
      info_tree.value = set_visibility_by_sensitivities_filter(info_tree.value);

      selected_item.value = props.l1
        ? SharedState.allInfoTypes.value[_l0_l1.value[1]]
        : SharedState.allInfoTypes.value[_l0_l1.value[0]];

      selected_item_name.value = selected_item.value?.labelName;
    };

    onMounted(() => {
      setTimeout(() => {
        set_tree();
      }, 100);

      subs.l0l1 = watch(_l0_l1, () => {
        set_tree();
      });
    });

    onBeforeUnmount(() => Object.values(subs).forEach((unsub) => unsub()));

    const select_info_type = (item: InformationType) => {
      selected_item.value = item;
      selected_item_name.value = item.labelName;
      emit("on_select", item.id);
      show_popup.value = false;
    };

    return {
      _l0_l1,
      show_popup,
      info_tree,
      selected_item_name,
      selected_item,
      select_info_type,
    };
  },
});
